﻿export const fr = {
  apply: "Appliquer",
  cart_is_empty: "Votre panier est vide. Découvrir les produits pour les ajouter à votre panier",
  browse_products: "Consulter les produits",
  invalid_coupon: "Le code de réduction saisi n’est pas valide. Veuillez vérifier le code et réessayer.",
  duplicate_coupon: "Le code de réduction {{couponInputValue}} a déjà été utilisé",
  products: "Produits",
  product: "Produit",
  qty: "QTÉ",
  price: "Prix",
  remove: "Retirer",
  add_to_cart: "Ajouter au panier",
  show_more: "Afficher plus",
  show_less: "Afficher moins",
  order_summary: "Résumé de la commande",
  your_cart: "Votre panier",
  item: "article",
  items: "articles",
  enter_discount_code: "Saisir le code de réduction",
  continue_shopping: "Continuer les achats",
  i_agree: "En continuant, je reconnais avoir lu et accepté la",
  privacy_policy: "Politique de confidentialité",
  refund_policy: "Politique de remboursement",
  terms_of_use: "Modalités",
  and: "et",
  total: "Total",
  exclude: "HT",
  include: "TTC",
  tax: "Taxe",
  subtotal: "Sous-total",
  discount: "Réduction",
  coupon_discount: "Bon de réduction",
  checkout: "Paiement"
};